export function Or<T>(value: T | undefined, defaultValue: T): T {
	return value !== undefined ? value : defaultValue;
}

export function FromOr<TOutput>(source: any, property: string, defaultValue: TOutput): TOutput {
	return source ? source[property] : defaultValue;
}
